import { colors } from "@styles/colors";
import React, { ReactNode } from "react";
import { ZStack, XStack, Text, YStack, StackProps, View } from "tamagui";

type ThemeType = "primary" | "amber" | "purple" | "green" | "gray";
const themeColorMap: Record<ThemeType, string> = {
  primary: colors.primaryActive,
  amber: colors.bgAmber,
  purple: colors.bgPurple,
  green: colors.bgGreen,
  gray: colors.bgGray1,
};
const RadiusBoxLabel = ({
  label,
  desc,
  icon,
  theme = "primary",
  flexDirection = "row",
  alignItems = "center",
}: {
  label?: string | ReactNode;
  desc?: string | ReactNode;
  icon?: ReactNode;
  theme?: ThemeType;
  flexDirection?: StackProps["flexDirection"];
  alignItems?: StackProps["alignItems"];
}) => {
  return (
    <XStack flexDirection={flexDirection} alignItems={alignItems} gap="$2">
      {icon && (
        <ZStack backgroundColor={themeColorMap[theme]} width={32} height={32} borderRadius="$3" flexShrink={0}>
          <XStack fullscreen alignItems="center" justifyContent="center">
            {icon}
          </XStack>
        </ZStack>
      )}
      <YStack>
        {typeof label === "string" ? <Text fontWeight="bold">{label}</Text> : label}
        {desc ? (
          <Text fontSize={14} color={colors.gray}>
            {desc}
          </Text>
        ) : null}
      </YStack>
    </XStack>
  );
};

export default RadiusBoxLabel;
